import { URL } from 'whatwg-url';

const protocols = /^http|^https/g;
export const isPathMatched = (currentPath, targetPath) => {
  /*
   * サイドバーのリンク先はすべてowner.retty.me内のページが想定されていたが
   * https://github.com/RettyInc/ebisu-zz/issues/10688
   * により外部のURLも設定できるようにしないといけないため
   * 外部URL（http or httpsが含まれている場合）はactiveチェックをしないように変更
   */
  if (protocols.test(targetPath)) {
    return false;
  }

  let origin = window.location.origin;
  if (origin === undefined) {
    origin = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ''
    }`;
  }
  return new URL(`${origin}${currentPath}`).pathname === new URL(`${origin}${targetPath}`).pathname;
};

export const hasRelationPath = (currentPath, relationPaths) =>
  relationPaths.some(relationPath => isPathMatched(currentPath, relationPath));

const titleCategoryIconMap = {
  トップ: 'home',
  予約: 'booking',
  予約基本設定: 'setting',
  席: 'seat',
  コース: 'course',
  メニュー: 'menu',
  店舗情報: 'restaurant_editing',
  投稿: 'post',
  人気店ページ設定: 'ad_editing',
  外部連携: 'external_connect',
  ホームページ: 'homepage_settings',
  分析レポート: 'analysis',
  口コミ: 'message',
  アカウント情報: 'account_setting',
};

export const getCategoryIconNameFromTitle = title => titleCategoryIconMap[title] || '';
